import { EventName } from '@lit/react';
import { BlocksButton } from 'blocks-nextjs/blocks-web-components/components/button/button';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';

export const CatButton = createComponent({
  react: React,
  tagName: 'cat-button',
  elementClass: BlocksButton,
  events: {
    onClick: 'click' as EventName<MouseEvent>
  }
});
